import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as AbsiTemplateSectionActions from './absi-template-section.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class AbsiTemplateSectionStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initStore() { }

  initListeners() {
    // ABSI Template Sections
    this.signalRService.hubConnection?.on(Channels.ABSI_TEMPLATE_SECTIONS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new AbsiTemplateSectionActions.AbsiTemplateSectionCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new AbsiTemplateSectionActions.AbsiTemplateSectionUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new AbsiTemplateSectionActions.AbsiTemplateSectionDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new AbsiTemplateSectionActions.AbsiTemplateSectionRefresh(data.id, data.obj));
          break;

      }
    });
  }
}
